import React, { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { listAccessibleGroupsAPI } from '../../../../store/features/listGroup';
import { AddCoUserToGroupApi } from '../../../../store/features/AddCoUserToGroups';
import { Avatar, Box, TextField, InputAdornment, CircularProgress, ClickAwayListener } from '@mui/material';
import { ReactComponent as SearchIcon } from '../../../../assets/images/TicketImages/search.svg';
import { ReactComponent as ChevronDown } from "../../../../assets/images/dropdown-arrow.svg";
import NoSearch from '../../../common/NoSearch';



export default function CoUserGroup(props) {
  const [data, setData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [localSelectedGroups, setLocalSelectedGroups] = useState([]);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const containerRef = useRef(null);

  const {
    setSelectedGroups, selectedGroups, setAddNewGroupUser, setAddGroupGeneral, addGroupGeneral,
  } = props;
  const userId = props.userID ?? useParams().userId;

  const styles = {
    selector: {
      borderRadius: "8px",
      background: "#FFF",
      boxShadow: "0px 1px 2px rgba(6, 21, 34, 0.05)",
      border: "1px solid #D5DCE1",
      height: "40px",
      fontSize: "14px",
      padding: "0px 16px",
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      cursor: 'pointer',
      transition: 'border-color 0.2s',
    },
    dropdown: {
      position: 'absolute',
      top: "calc(100% + 8px)",
      left: 0,
      right: 0,
      zIndex: 1300,
      border: "1px solid #E5E7EB",
      borderRadius: "8px",
      padding: "8px",
      maxHeight: "224px",
      backgroundColor: "#FFFFFF",
      boxShadow: "0px 4px 6px -1px rgba(0, 0, 0, 0.1)",
      display: 'flex',
      flexDirection: 'column'
    },
    searchField: {
      position: "sticky",
      top: 0,
      backgroundColor: "#fff",
      zIndex: 1000,
      marginBottom: '8px'
    },
    listContainer: {
      maxHeight: "220px",
      overflowY: "auto",
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
      scrollbarWidth: 'thin',
      '&::-webkit-scrollbar': {
        width: '6px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
        borderRadius: '3px',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#c1c1c1',
        borderRadius: '3px',
        '&:hover': {
          background: '#a8a8a8',
        },
      },
    },
    groupItem: {
      display: "flex",
      alignItems: "center",
      gap: '8px',
      fontFamily: 'Inter',
      fontSize: '14px',
      fontWeight: '400',
      padding: '8px',
      borderRadius: '8px',
      cursor: 'pointer',
      color: "#556575",
      transition: 'background-color 0.2s',
      '&:hover': {
        color: '#061522',
        backgroundColor: "#F9FAFA !important"
      }
    },
    selectedGroup: {
      color: '#061522',
      backgroundColor: "#F9FAFA !important"
    },
    avatar: {
      width: 24,
      height: 24,
      fontSize: "0.75rem"
    },
    groupTitle: {
      fontSize: "14px",
      color: "#061522",
      fontFamily: "Inter",
      fontWeight: 400,
      textTransform: "capitalize",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      maxWidth: "200px",
    },
    placeholder: {
      color: "#405261",
      fontSize: "14px",
      fontFamily: "Inter",
      fontWeight: 400,
    }
  };

  const getGroupsList = async () => {
    setLoading(true);
    const outputarray = [];
    const listGroupDispatcher = dispatch(listAccessibleGroupsAPI());

    listGroupDispatcher
      .then(async (data) => {
        if (typeof data.payload === 'undefined') {
          toast.error('Some Error Occured. Please try again later.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        } else if (data?.payload?.status === 200) {
          data?.payload?.data?.map((item) => {
            outputarray.push({
              id: item?.id,
              title: item?.title,
              group_image: item?.group_image,
            });
          });
          setData(outputarray);
        } else if (data?.payload?.status === 500) {
          toast.error('Some Error Occured. Please try again later.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        } else if (data?.payload?.status === 401) {
          toast.error('Login Expired. Please login and try again.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
          navigate('/login');
        }
      })
      .catch(async (error) => {
        toast.error(error, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const AddCoUserToGroup = async () => {
    const AddUserToGroup = dispatch(
      AddCoUserToGroupApi({
        id: userId,
        requestHeaders: {
          agent_group_ids: selectedGroups,
        },
      }),
    );

    AddUserToGroup
      .then(async (data) => {
        if (typeof data.payload === 'undefined') {
          toast.error('Some Error Occured. Please try again later.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        } else if (data?.payload?.status === 200) {
          toast.success(data.payload.message);
          setSelectedGroups([]);
          setAddNewGroupUser([]);
          setLocalSelectedGroups([])
          setIsOpen(false)

        } else if (data?.payload?.status === 400) {
          toast.error('Some Error Occured. Please try again later.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
          alert(data.payload.message);
        } else if (data?.payload?.status === 401) {
          toast.error('Login Expired. Please login and try again.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
          navigate('/login');
        }
      })
      .catch(async (error) => {
        toast.error(error, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        });
      });
  };

  const chracterPosition = (alphabet) => {
    const alphabets = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const positionOfAlphabet = alphabets.indexOf(alphabet) + 1;
    return positionOfAlphabet;
  };
  const colorCodesForAvatar =
    ['#405261', // A
      '#FF4D4F', // B
      '#FA541C', // C
      '#FA8C16', // D
      '#FAAD14', // E
      '#EB2F96', // F
      '#FADB14', // G
      '#A0D911', // H
      '#52C41A', // I
      '#5CDBD3', // J
      '#9254DE', // K
      '#F759AB', // L
      '#2F54EB', // M
      '#722ED1', // N
      '#1890FF', // O
      '#13C2C2', // P
      '#2DB7F5', // Q
      '#19BE6B', // R
      '#30A745', // S
      '#FA8C16', // T
      '#FAAD14', // U
      '#9254DE', // V
      '#F759AB', // W
      '#13C2C2', // X
      '#722ED1', // Y
      '#2DB7F5', // Z];
    ]


  const handleGroupChange = (newValue) => {
    const newSelectedGroups = newValue.map((group) => group.id);
    setSelectedGroups(newSelectedGroups);
    setAddNewGroupUser(newValue);
    setLocalSelectedGroups(newValue);

    const existingGroups = addGroupGeneral.map(group => group.id);
    const newGroupsToAdd = newValue.filter(
      (newGroup) => !existingGroups.includes(newGroup.id)
    ).map((group) => ({
      id: group.id,
      title: group.title,
    }));

    setAddGroupGeneral((prevGroups) => [...prevGroups, ...newGroupsToAdd]);
  };

  const handleGroupSelect = (group) => {
    const isSelected = localSelectedGroups.some(g => g.id === group.id);
    let newSelectedGroups;

    if (isSelected) {
      newSelectedGroups = localSelectedGroups.filter(g => g.id !== group.id);
    } else {
      newSelectedGroups = [...localSelectedGroups, group];
    }

    handleGroupChange(newSelectedGroups);
  };

  // Filter groups based on search and exclude already added groups
  const filteredGroups = data.filter((group) => {
    const matchesSearch = group.title.toLowerCase().includes(searchTerm.toLowerCase());
    const notAlreadyAdded = !addGroupGeneral.some((addedGroup) =>
      addedGroup._id === group.id || addedGroup.id === group.id
    );
    return matchesSearch && notAlreadyAdded;
  });

  const handleToggle = () => {
    setIsOpen(!isOpen);
    if (!isOpen) {
      setSearchTerm("");
    }
  };

  const handleClickAway = () => {
    setIsOpen(false);
  };

  const getSelectedGroupsText = () => {
    if (localSelectedGroups.length === 0) return 'Select groups';
    if (localSelectedGroups.length === 1) return localSelectedGroups[0].title;
    if (localSelectedGroups.length === 2) {
      return `${localSelectedGroups[0].title}, ${localSelectedGroups[1].title}`;
    }
    return `${localSelectedGroups[0].title}, ${localSelectedGroups[1].title} +${localSelectedGroups.length - 2} more`;
  };

  useEffect(() => {
    getGroupsList();
  }, []);

  useEffect(() => {
    if (selectedGroups.length > 0) {
      AddCoUserToGroup();
    }
  }, [selectedGroups]);

  return (
    <div className="field-wrapper">

      <ClickAwayListener onClickAway={handleClickAway}>
        <Box sx={{ position: 'relative', width: '100%' }}>
          {/* Main Selector Box */}
          <Box
            ref={containerRef}
            onClick={handleToggle}
            sx={styles.selector}
          >
            {/* Selected Value Display */}
            {localSelectedGroups.length === 0 ? (
              <span style={styles.placeholder}>
                Select groups
              </span>
            ) : (
              <Box sx={{ display: "flex", alignItems: "center", gap: "8px", flex: 1, minWidth: 0 }}>
                <span style={styles.groupTitle}>
                  {getSelectedGroupsText()}
                </span>
              </Box>
            )}

            {/* Dropdown Arrow */}
            <ChevronDown style={{
              transform: isOpen ? "rotate(180deg)" : "rotate(0)",
              transition: "transform 0.2s",
              color: "#9CA3AF"
            }} />
          </Box>

          {/* Dropdown List */}
          {isOpen && (
            <Box sx={styles.dropdown}>
              {/* Search Field */}
              <Box sx={styles.searchField}>
                <TextField
                  fullWidth
                  autoFocus
                  variant="outlined"
                  placeholder="Search group"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <SearchIcon className="search-icon-search" />
                      </InputAdornment>
                    ),
                    sx: {
                      "& fieldset": { border: "1px solid #D5DCE1" },
                      "& input": {
                        height: "40px",
                        padding: "0px 16px",
                        fontSize: "14px",
                        fontFamily: "Inter",
                        fontWeight: 400,
                        color: "#111827 !important",
                        cursor: "text !important",
                        backgroundColor: "transparent",
                        "&::placeholder": {
                          color: "#C5CED6",
                          opacity: 1,
                          fontSize: "14px",
                          fontFamily: "Inter",
                          fontWeight: 400,
                        },
                      },
                    },
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "#fff",
                      borderRadius: "8px",
                      "&.Mui-focused fieldset": { border: "1px solid #3B82F6" },
                    },
                  }}
                />
              </Box>

              {/* No Results State */}
              {!loading && (searchTerm ? filteredGroups : data.filter(group => {
                return !addGroupGeneral.some(
                  addedGroup => addedGroup._id === group.id || addedGroup.id === group.id
                );
              })).length === 0 && (
                  <NoSearch
                    title="No group found"
                    description={searchTerm ? "Clear your search and try again." : ""}
                    titleFontSize={14}
                    descriptionFontSize={12}
                  />
                )}

              {/* Scrollable List Container */}
              <Box sx={styles.listContainer}>
                {/* Loading State */}
                {loading && (
                  <Box sx={{ display: "flex", justifyContent: "center", padding: "16px" }}>
                    <CircularProgress size={20} />
                  </Box>
                )}

                {/* Group Items */}
                {!loading && (searchTerm ? filteredGroups : data.filter((group) => {
                  return !addGroupGeneral.some((addedGroup) =>
                    addedGroup._id === group.id || addedGroup.id === group.id
                  );
                })).map((group) => {
                  const isSelected = localSelectedGroups.some(g => g.id === group.id);
                  return (
                    <Box
                      key={group.id}
                      onClick={() => handleGroupSelect(group)}
                      sx={{
                        ...styles.groupItem,
                        ...(isSelected && styles.selectedGroup)
                      }}
                    >
                      <Avatar
                        sx={{
                          height: 24,
                          width: 24,
                          fontSize: 14,
                          bgcolor: group.group_image ? "transparent" : colorCodesForAvatar[
                            chracterPosition(
                              group.title.substring(0, 1).toUpperCase(),
                            )
                          ],
                        }}
                        src={group.group_image}
                      >
                        {!group.group_image && group.title?.charAt(0).toUpperCase()}
                      </Avatar>
                      <Box sx={{ overflow: "hidden", flex: 1 }}>
                        <Box>
                          {group.title}
                        </Box>
                      </Box>
                    </Box>
                  );
                })}
              </Box>
            </Box>
          )}
        </Box>
      </ClickAwayListener>
    </div>
  );
}